import IconAsMaskImage from '../IconAsMaskImage'

const ReplyLeft = ({ pureSvg, className, color, ...rest }) => {
  const svg = (
    <>
      <svg {...rest} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.75781 6V6.75C3.75781 7.99268 4.76517 9 6.00781 9H14.243M14.243 9C13.2653 7.98322 12.2552 6.99737 11.2578 6M14.243 9C13.2653 10.0168 12.2552 11.0026 11.2578 12"
          stroke="black"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default ReplyLeft
